<app-service-map
  [accent]="'market-data'"
  [entries]="marketsList"
  [loading]="loading"
  [popupBuilder]="buildPopup"
  [pops]="commercialPopList"
  [title]="'Market Data Service Map'">
</app-service-map>
